import React from 'react';
import { Form, Input, Typography, Card } from 'antd';
import type { FormInstance } from 'antd';
import { useTranslation } from 'react-i18next';

const { TextArea } = Input;
const { Title, Text } = Typography;

interface WithdrawSettingsProps {
  form: FormInstance;
}

const WithdrawSettings: React.FC<WithdrawSettingsProps> = ({ }) => {
  const { t } = useTranslation();
  
  return (
    <Card title={t('settings.withdrawSettings.title')} variant="outlined">
      <Typography.Paragraph>
        {t('settings.withdrawSettings.withdrawMessage')}
        <ul>
          <li><Text code>{'{username}'}</Text> - {t('settings.withdrawSettings.username')}</li>
          <li><Text code>{'{monto_retiro}'}</Text> - {t('settings.withdrawSettings.withdrawAmount')}</li>
          <li><Text code>{'{balance_actual}'}</Text> - {t('settings.withdrawSettings.actualBalance')}</li>
          <li><Text code>{'{titular_retiro}'}</Text> - {t('settings.withdrawSettings.accountHolder')}</li>
          <li><Text code>{'{cvucbu_retiro}'}</Text> - {t('settings.withdrawSettings.withdrawCVU')}</li>
          <li><Text code>{'{alias_retiro}'}</Text> - {t('settings.withdrawSettings.withdrawAlias')}</li>
          <li><Text code>{'{operation_id}'}</Text> - {t('settings.withdrawSettings.operationID')}</li>
          <li><Text code>{'{rejection_reason}'}</Text> - {t('settings.withdrawSettings.rejectionReason')}</li>
        </ul>
      </Typography.Paragraph>

      <Title level={5}>{t('settings.withdrawSettings.approvedMessage')}</Title>
      <Form.Item
        name="withdrawApprovedMessage"
        tooltip="Variables: {username}, {monto_retiro}, {balance_actual}, {titular_retiro}, {cvucbu_retiro}, {alias_retiro}, {operation_id}, {faltante}, {bonus_amount}, {retirable}"
      >
        <TextArea rows={6} placeholder={t('settings.withdrawSettings.approvedMessage')} />
      </Form.Item>

      <Title level={5}>{t('settings.withdrawSettings.confirmationMessage')}</Title>
      <Form.Item name="withdrawConfirmationMessage">
        <TextArea rows={4} placeholder={t('settings.withdrawSettings.confirmationMessage')} />
      </Form.Item>

      <Title level={5}>{t('settings.withdrawSettings.rejectedMessage')}</Title>
      <Form.Item
        name="withdrawRejectedMessage"
        tooltip="Variables: {username}, {monto_retiro}, {balance_actual}, {rejection_reason}, {faltante}, {bonus_amount}, {retirable}"
      >
        <TextArea rows={6} placeholder={t('settings.withdrawSettings.rejectedMessage')} />
      </Form.Item>
    </Card>
  );
};

export default WithdrawSettings;